// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
}

svg {
  height: var(--sprite-image-height, 1em);
  width: var(--sprite-image-width, auto);
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./../shared/ng/components/sprite-image/sprite-image.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;AACF;;AAEA;EACE,uCAAA;EACA,sCAAA;EACA,sBAAA;AACF","sourcesContent":[":host {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n}\n\nsvg {\n  height: var(--sprite-image-height, 1em);\n  width: var(--sprite-image-width, auto);\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
